'use strict';

import errorNotice from './../error';
import municipalities from './municipality';
import municipalityTable from './municipality-stats';
import municipalitiesPerDay from './municipalities-per-day';
import dataHandler from './../data-handler';
import { changeDates } from './../helpers';

const municipalityCharts = (function(){
    let dateElems = null;

    function init(data) {
        if (typeof data.municipalities !== 'undefined') {
            dateElems = document.querySelectorAll('.js-date-municipalities');

            municipalityTable.init(data);

            // Create map of municipality ids and names
            data.municipalityIdMap = {};
            for (const key of Object.keys(data.municipalities)) {
                const municipality = data.municipalities[key];
                if (typeof data.municipalityIdMap[municipality.id] === 'undefined') {
                    data.municipalityIdMap[municipality.id] = key;
                }
            }

            // Init charts
            municipalities.init(data);
            municipalitiesPerDay.init(data);

        } else {
            const error = 'Ongelma THL rajapinnassa, dataa kunnista ei saatavilla.';
            errorNotice.showDataError(error);
        }
    }

    function reload(data, page) {
        const reloadCharts = [];

        if (page.classList.contains('reload-rate')) {
            const municipalityChartModeInput = document.querySelector('input[name="municipality-chart-data"]:checked');

            // If rate mode selected in municipality chart, update
            if (municipalityChartModeInput.value === 'rate' && reloadCharts.indexOf('municipalities') === -1) {
                reloadCharts.push('municipalities');
            }

            reloadCharts.push('municipality-table');

            page.classList.remove('reload-rate');
        }

        if (page.classList.contains('reload-date')) {
            // Update first day values
            // Get existing municipality
            const municipality = Object.keys(data.municipality)[0];
            const municipalityChartFirstDay = dataHandler.getChartFirstDate(data.municipality[municipality].days[0].date);
            window.config.firstDayValues['municipalities'] = municipalityChartFirstDay;
            changeDates(municipalityChartFirstDay, dateElems);

            if (reloadCharts.indexOf('municipalities') === -1) {
                reloadCharts.push('municipalities');
            }
            if (reloadCharts.indexOf('municipalities-per-day') === -1) {
                reloadCharts.push('municipalities-per-day');
            }

            page.classList.remove('reload-date');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'municipalities') {
                municipalities.reload(data);
            }
            if (chartType === 'municipalities-per-day') {
                municipalitiesPerDay.reload(data);
            }

            if (chartType === 'municipality-table') {
                municipalityTable.reload(data);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload
    }
})();

export default municipalityCharts;
